<app-content-shell [resizablePanel]="true">

  <app-header mainHeader />

  <app-panel-header panelHeader [title]="getTabTitle()">
    <button
      action
      mat-icon-button
      (click)="addNewItem()"
      [matTooltip]="getAddButtonTooltip()"
      [attr.aria-label]="getAddButtonTooltip()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </app-panel-header>

  <app-panel-tabs
    panelTabs
    [tabs]="tabLabels"
    [(active)]="activeTabLabel"
    (activeChange)="onTabLabelChange($event)"
  />

  @if (activeTabLabel === 'Sources') {
    <div panelSearch>
      <app-panel-search [(query)]="sourcesSearchQuery" placeholder="Search sources..." />
    </div>
  }

  <div panelContent>
    @if (activeTabLabel === 'Sources') {
      @if (foldersLoading) {
        <app-spinner [message]="''" />
      } @else {
        @for (item of filteredFolders; track item._id) {
          <app-list-item [selected]="selectedFolder?._id === item._id" [hasMenu]="true" (click)="goToFolder(item)">
            @if (hasIcon(item)) {
              @if (isCustomIcon(item)) {
                <mat-icon itemIcon [ngClass]="getItemCss(item)" svgIcon="{{ item.icon }}" />
              } @else {
                <mat-icon itemIcon [ngClass]="getItemCss(item)">{{ item.icon }}</mat-icon>
              }
            }
            <span itemTitle>{{ item.title }}</span>
            <ng-container itemSuffix>
              @if (hasSuffix(item)) {
                <span class="suffix-text">{{ item.sufix }}</span>
              }
              @if (item.approved) {
                <mat-icon class="approval-tick" matTooltip="Approved">check_circle</mat-icon>
              }
            </ng-container>
            <ng-container itemMenu>
              <button mat-menu-item (click)="openEditSourceFolderModal(item, $event)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="openDeleteItemModal(item, $event)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </ng-container>
          </app-list-item>
        }
      }
    }

    @if (activeTabLabel === 'Materials') {
      <app-materials-folders />
    }

    @if (activeTabLabel === 'Context') {
      <app-context-groups-list
        #contextGroupsList
        (groupSelected)="handleContextGroupSelected($event)"
      />
    }
  </div>

  <div mainContent class="sources-main-content" [class.full-height-annotations]="isAnnotationsView">
    @if (activeTabLabel === 'Sources' && (selectedFolder || selectedSource)) {
      <div class="sources-workspace-header">
        @if (hasBreadcrumbs()) {
          <div class="workspace-breadcrumbs">
            <button type="button" class="breadcrumb-button" (click)="openSourcesRoot()"> Sources </button>
            @if (selectedFolder) {
              <span class="breadcrumb-separator">/</span>
              <button type="button" class="breadcrumb-button" (click)="openSelectedFolder()"> {{ selectedFolder.title }} </button>
            }
            @if (selectedSource) {
              <span class="breadcrumb-separator">/</span>
              <span class="breadcrumb-current">{{ selectedSource.name }}</span>
            }
          </div>
        }

        <div class="workspace-header-main">
          <div class="workspace-copy">
            @let contentTitle = getContentTitle();
            @if (contentTitle) { <h2>{{ contentTitle }}</h2> }
          </div>

          @if (selectedSource) {
            <div class="workspace-actions">
              @if (!isAnnotationsView) {
                <button mat-stroked-button type="button" color="primary" (click)="openSelectedSourceAnnotations()" > <mat-icon>rate_review</mat-icon> Annotations </button>
              }
              @if (isAnnotationsView) {
                <button mat-stroked-button type="button" color="primary" (click)="openSelectedSourceOverview()" > <mat-icon>description</mat-icon> Source overview </button>
              }
            </div>
          }
        </div>
      </div>
    }
    <router-outlet />
  </div>

</app-content-shell>
